import { NAV_BY_ROLE, type Role } from '../config';
import { setRoute } from '../router';

const ICON_SVG: Record<string, string> = {
  over:   `<rect x='2' y='2' width='7' height='7' rx='1.5'/><rect x='11' y='2' width='7' height='7' rx='1.5'/><rect x='2' y='11' width='7' height='7' rx='1.5'/><rect x='11' y='11' width='7' height='7' rx='1.5'/>`,
  users:  `<circle cx='7' cy='7' r='3'/><circle cx='13' cy='13' r='3'/><path d='M2 16c0-2.761 2.239-5 5-5M11 13v5M8.5 15.5h5'/>`,
  book:   `<path d='M4 4h12v12H4z'/><path d='M4 8h12'/>`,
  tick:   `<path d='M3 7l4 4 10-10'/>`,
  pipe:   `<circle cx='5' cy='10' r='2'/><circle cx='15' cy='4' r='2'/><circle cx='15' cy='10' r='2'/><circle cx='15' cy='16' r='2'/>`,
  cash:   `<path d='M2 10h4l3-7 4 14 3-7h2'/>`,
  wallet: `<path d='M3 7h13v10H3z'/><path d='M16 11h2v4h-2z'/><circle cx='8' cy='13' r='1.5'/>`,
  team:   `<circle cx='10' cy='7' r='3'/><path d='M3 18c0-3.866 3.134-7 7-7s7 3.134 7 7'/>`,
  staff:  `<path d='M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6M3 18a6 6 0 1 1 12 0'/><path d='M17 11l1 1 3-3'/>`,
  gear:   `<circle cx='10' cy='10' r='3'/><path d='M10 2v3M10 15v3M2 10h3M15 10h3M4 4l2 2M14 14l2 2M4 16l2-2M14 6l2-2'/>`,
  globe:  `<circle cx='12' cy='12' r='8'/><path d='M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18'/>`,
  batch:  `<rect x='3' y='4' width='14' height='12' rx='2'/><path d='M6 2v4M14 2v4M3 8h14M7 12h3'/>`,
  inbox:  `<path d='M3 4h14v12H3z'/><path d='M3 12h4l1 2h4l1-2h4'/>`,
};

export function renderRail(role: Role, active: string) {
  return NAV_BY_ROLE[role].map((sec) => `
    <div class="rail-section">${sec.section}</div>
    ${sec.items.map((it) => `
      <div class="rail-item ${active === it.id ? 'active' : ''}" data-route="${it.id}">
        <svg class="ri-icon" viewBox="0 0 20 20">${ICON_SVG[it.icon] || ''}</svg>
        ${it.label}
        ${it.badge ? `<span class="ri-badge">${it.badge}</span>` : ''}
      </div>`).join('')}
  `).join('');
}
export function bindRailClicks() {
  document.querySelectorAll<HTMLElement>('.rail-item[data-route]').forEach((el) => {
    el.addEventListener('click', () => setRoute(el.dataset.route as never));
  });
}

const M_ICONS: Record<string, string> = {
  over:   `<rect x='3' y='3' width='9' height='9' rx='2'/><rect x='14' y='3' width='9' height='9' rx='2'/><rect x='3' y='14' width='9' height='9' rx='2'/><rect x='14' y='14' width='9' height='9' rx='2' fill='currentColor'/>`,
  book:   `<path d='M5 5h14v14H5z'/><path d='M5 9h14'/>`,
  pipe:   `<circle cx='7' cy='12' r='2'/><circle cx='17' cy='6' r='2'/><circle cx='17' cy='12' r='2'/><circle cx='17' cy='18' r='2'/><line x1='9' y1='12' x2='15' y2='12'/>`,
  wallet: `<path d='M4 8h16v12H4z'/><path d='M14 12h4'/><circle cx='8' cy='14' r='2'/>`,
  gear:   `<circle cx='12' cy='12' r='3'/><path d='M12 5v3M12 16v3M5 12h3M16 12h3M7 7l2 2M15 15l2 2M7 17l2-2M15 7l2-2'/>`,
  staff:  `<path d='M9 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6'/><path d='M3 18a6 6 0 0 1 12 0M16 9l2 2 4-4'/>`,
  batch:  `<rect x='5' y='5' width='14' height='14' rx='2'/><path d='M8 3v4M16 3v4M5 9h14'/>`,
};

export function renderBottomSheet(active: string) {
  const cleaned = [
    { id: 'overview',   icon: M_ICONS.over,   label: 'Today' },
    { id: 'courses',    icon: M_ICONS.book,   label: 'Courses' },
    { id: 'attendance', icon: M_ICONS.staff,  label: 'Attend', isFab: false },
    { id: 'payroll',    icon: M_ICONS.wallet, label: 'Pay', isFab: false },
    { id: 'settings',   icon: M_ICONS.gear,   label: 'Me', isFab: false },
  ];
  // Insert FAB in the middle slot
  const out: string[] = [];
  cleaned.forEach((it, idx) => {
    if (idx === 2) {
      out.push(`<div class="bs-item bs-fab touch-target" data-bs-fab>+</div>`);
    }
    out.push(`<div class="bs-item ${active === it.id ? 'active' : ''}" data-route="${it.id}">
      <svg class="bs-icon" viewBox="0 0 24 24">${it.icon}</svg>
      ${it.label}
    </div>`);
  });
  return `<nav class="bottom-sheet" aria-label="Primary">${out.join('')}</nav>`;
}
